module.exports = __webpack_public_path__ + "static/media/aw.749fc6d1.svg";